module.exports = __webpack_public_path__ + "img/environment-transparent.bfb813ca.png";